import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ChevronLeft, ChevronRight } from '@factorialco/f0-react/icons/app'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

interface JobCatalogSearchResult {
  id: string
  name: string
  type: string
  node_uuid: string
  score: number
}

interface Props {
  results: JobCatalogSearchResult[]
  onResultChange: (result: JobCatalogSearchResult | undefined) => void
  search: string
}

const JobCatalogSearchResultsNavigator: React.FC<Props> = ({ results, search, onResultChange }) => {
  const [index, setIndex] = React.useState(0)

  useEffect(() => {
    setIndex(0)
    onResultChange(results[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results[0]?.id])

  const handlePrevious = () => {
    const isFirstResult = index <= 0

    if (isFirstResult) {
      handleClick(results.length - 1)
    } else {
      handleClick(index - 1)
    }
  }

  const handleNext = () => {
    const isLastResult = index + 1 >= results.length

    if (isLastResult) {
      handleClick(0)
    } else {
      handleClick(index + 1)
    }
  }

  const handleClick = (nextIndex: number) => {
    setIndex(nextIndex)
    onResultChange(results[nextIndex])
  }

  return (
    <>
      {search && (
        <Box
          flexDirection="row"
          border={{
            all: {
              color: 'grey400',
              width: 's1',
              style: 'solid',
            },
          }}
          background="grey000White"
          borderRadius={{
            all: 'abs016',
          }}
          alignItems="center"
          justifyContent="flexEnd"
          paddingBottom="s2"
          paddingTop="s4"
          paddingX="s8"
          gap="s4"
        >
          <F0Button
            hideLabel
            icon={ChevronLeft}
            onClick={handlePrevious}
            round
            size="sm"
            variant="ghost"
          />
          <Text.Normal color={!results ? 'grey600' : 'grey800'} size="200">
            {i18n.t('employees.orgchart.results', {
              index: results.length ? index + 1 : 0,
              length: results.length,
            })}
          </Text.Normal>
          <F0Button
            hideLabel
            icon={ChevronRight}
            onClick={handleNext}
            round
            size="sm"
            variant="ghost"
          />
        </Box>
      )}
    </>
  )
}

export default JobCatalogSearchResultsNavigator
